export default "__VITE_ASSET__CNiKqdUH__"